import React from 'react';
import {
  MobileTimePicker as MUIMobileTimePicker,
  MobileTimePickerProps,
} from '@mui/x-date-pickers/MobileTimePicker';
import Input from '../Input';
import type { Moment } from 'moment';

const TextFieldAdapter = React.forwardRef<HTMLDivElement, any>((props, ref) => {
  return <Input {...props} ref={ref as any} />;
});

interface TimerPickerProps extends Omit<MobileTimePickerProps<any>, 'slots'> {
  InputProps?: any;
  value?: Moment | null;
  onChange?: (value: Moment | null) => void;
}

const TimerPicker = (props: TimerPickerProps) => {
  const { InputProps, slotProps, ...otherProps } = props;

  return (
    <MUIMobileTimePicker
      {...otherProps}
      slots={{
        textField: TextFieldAdapter,
      }}
      slotProps={{
        ...slotProps,
        textField: {
          ...slotProps?.textField,
          ...InputProps,
        },
      }}
    />
  );
};

export default TimerPicker;
